import { Component, OnInit } from '@angular/core';
import { TransferHttpService } from 'src/app/services/transfer-http/transfer-http.service';
import { PermissionsService } from 'src/app/services/permissions/permissions.service';
import { LogShippingCommLi } from 'src/models';
import { Observable } from 'rxjs';
import { AimsCommonTableHeader, AimsCommonTablePermissions } from '@aims/common-components';
import { GetTextPipe } from 'src/app/pipes';

@Component({
  selector: 'app-inventory-ibn',
  templateUrl: './inventory-ibn.component.html',
  styleUrls: ['./inventory-ibn.component.css'],
  providers: [GetTextPipe]
})
export class InventoryIbnComponent implements OnInit {

  //Spinner
  spinnerText: string = "Loading...";
  showSpinner: boolean = false;
  currentLogShippingCommLi: LogShippingCommLi;

  // AimsCommonTable setup
  header: AimsCommonTableHeader[] = [
    { key: 'inventory', label: 'Inventory', type: 'dynamic'},
    { key: 'ibnlink', label: 'IBN ID', type: 'dynamic', width: 80,
      events: { filterAndSort: (element) => element.shippingHeaderId } },
    { key: 'polink', label: 'PO/Req/SR ID', type: 'dynamic',
      events: { filterAndSort: (element) =>
                  element.po?.poId || element.reqLineItem?.reqId || element.shippingRequestItem?.shippingRequestHdrId } },
    { key: 'lineno', label: 'Line #', type: 'dynamic',
      events: { filterAndSort: (element) =>
                element.po?.poLnNo.toString() || element.reqLineItem?.lineNumber.toString() } },
    { key: 'for', label: 'For', type: 'string'},
    { key: 'nomenclature', label: 'Nomenclature', type: 'dynamic', width: 200,
      events: { filterAndSort: (element) =>
                element.po?.poLnDesc ||
                element.reqLineItem?.nomenclature ||
                element.shippingRequestItem?.nomenclature } },
    { key: 'manfpartno', label: 'Manf Part No', type: 'dynamic',
      events: { filterAndSort: (element) => element.po?.manufPartId || element.reqLineItem?.partNumber } },
    { key: 'vendpartno', label: 'Vendor Part No', type: 'dynamic',
      events: { filterAndSort: (element) => element.po?.vendPartId || element.reqLineItem?.vendPartNumber } },
    { key: 'unitofissue', label: 'UI', type: 'dynamic',
      events: { filterAndSort: (element) =>
              element.po?.poLnUmCd || element.reqLineItem?.ui || element.shippingRequestItem?.ui } },
    { key: 'totalqty', label: 'Tot Qty', type: 'dynamic',
      events: { filterAndSort: (element) =>
              element.po?.ordQty || element.reqLineItem?.qtyOrdered || element.shippingRequestItem?.qtyReqShipped } },
    { key: 'qtyShipped', label: 'Qty Shipping', type: 'number'},
    { key: 'qtyReceived', label: 'Qty Received', type: 'number'},
    { key: 'hazmat', label: 'Hazmat', type: 'dynamic'},
    { key: 'rcvdby', label: 'Received By', type: 'dynamic',
      events: { filterAndSort: (element) => this.getTextPipe.transform(element.receivedById, 'employeeId', 'fullName', this.employeeValues) } }
  ];
  tablePermissions: AimsCommonTablePermissions = {
    create: false,
    update: false,
    delete: false,
    filter: false
  };

  employeeValues = this.transferHttp.getCache('employeeDropdown');
  lineItemsForInventory: Observable<any>;

  constructor(private transferHttp: TransferHttpService,
        public permissions: PermissionsService,
        private getTextPipe: GetTextPipe) { }

  ngOnInit(): void {
    this.loadLineItems();
  }

  public loadLineItems() {
    this.lineItemsForInventory =  this.transferHttp.getHot('inventory/GetLineItemsReadyForInventory');

    this.lineItemsForInventory .subscribe(lis => {
    });
  }

  public inventoryItem(dataItem) {
    this.currentLogShippingCommLi = dataItem;
  }

  public showInventoryItem(): boolean {
    return this.currentLogShippingCommLi != null;
  }

  public clearItem() {
    this.currentLogShippingCommLi = null;
  }

  // item has been received into inventory, get updated ibn
  public handleLineItemInventoried(): void {
    this.clearItem();
    this.loadLineItems();
  }
}
